import React, { useState , useEffect } from "react";
import { useRange } from "react-instantsearch";
const PriceRangeInput = () => {
  const { start, range, canRefine, precision, refine } = useRange({
    attribute: "price",
  });

  const step = 1 / Math.pow(10, precision || 0);

  // Initialize the slider value, if start is valid, otherwise use the range
  const initialValue = range.max;

  const [priceRange, setPriceRange] = useState(initialValue);

  useEffect(() => {
    setPriceRange(initialValue);
  }, [initialValue]);

  const handleSliderChange = (e) => {
    setPriceRange(e.target.value);
  };

  const handleSliderRelease = () => {
    refine([range.min, Number(priceRange)]);
  };

  return (
    <div className="relative py-6">
      <div className="flex justify-between w-full mb-3">
        <h3 className="text-lg font-bold self-center">Price range</h3>
        <span className="text-sm text-gray-500 dark:text-gray-400 mx-autofont-semibold self-center">
          Max : ${priceRange}
        </span>
      </div>
      
      <label htmlFor="labels-range-input" className="sr-only bg-thdark">
        Price range
      </label>
      <input
        id="labels-range-input"
        type="range"
        value={priceRange}
        min={range.min}
        max={range.max}
        step={step}
        onChange={handleSliderChange}
        onMouseUp={handleSliderRelease}
        onTouchEnd={handleSliderRelease}
        className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-thdark"
        disabled={!canRefine}
      />

      <div className=" mt-2 flex justify-between gap-4 w-full">
        <span className="text-sm text-black dark:text-gray-400 font-semibold">
           ${range.min}
        </span>
        <span className="text-sm text-black dark:text-gray-400  font-semibold">
           ${range.max}
        </span>
      </div>
    </div>
  );
};
export default PriceRangeInput;
